import { render, staticRenderFns } from "./NewMessengerConversationHeader.vue?vue&type=template&id=444055b2&scoped=true"
import script from "./NewMessengerConversationHeader.vue?vue&type=script&lang=js"
export * from "./NewMessengerConversationHeader.vue?vue&type=script&lang=js"
import style0 from "./NewMessengerConversationHeader.vue?vue&type=style&index=0&id=444055b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444055b2",
  null
  
)

export default component.exports